import React from 'react';
import { CalendarClock } from 'lucide-react';
import './reviewPostponement.css';

export const ReviewPostponementInfo = ({ review, prefix, showBadge = true }) => {
  const data = review.postponement;
  if (!data) return null;
  return <div className="review-postponement-info" data-testid={`${prefix}-postponement`}>
    {showBadge && review.is_postponed && <span className="review-postponement-badge" data-testid={`${prefix}-postponed-label`}>
      <CalendarClock size={14} className="shrink-0" />PENDIENTE DE RESOLVER - POSPUESTA
    </span>}
    <p className="text-xs whitespace-pre-wrap mt-2" data-testid={`${prefix}-postponed-note`}>{data.note}</p>
    <p className="text-xs mt-1" style={{ color: 'var(--color-text-muted)' }} data-testid={`${prefix}-postponed-author`}>
      {data.by_name} · {new Date(data.postponed_at).toLocaleString('es-ES')}
    </p>
  </div>;
};